export const getEncodedS3Url = (path) => {
    if (!path) return ""

    try {
      const parts = path.split("/")
      const encodedParts = parts.map((part, index) => {
        // Sadece dosya adı olan son parçayı encode et
        return index === parts.length - 1 ? encodeURIComponent(decodeURIComponent(part)) : part
      })

      return `${encodedParts.join("/")}`
    } catch (e) {
      return `${path}`
    }
  }